import { lazy } from 'react';

import { PositionGroups } from './pages/PositionGroups';

const AnalogProducts = {
  Advertisements: lazy(() => import('./pages/Advertisements')),
  AdvertisementsEdit: lazy(() => import('./pages/Advertisements/Edit')),
  AdvertisingSpaces: lazy(() => import('./pages/AdvertisingSpaces')),
  BranchClusters: lazy(() => import('./pages/BranchClusters')),
  BranchCountFactors: lazy(() => import('./pages/BranchCountFactors')),
  Dispatches: lazy(() => import('./pages/Dispatches')),
  Layout: lazy(() => import('./components/Layout')),
  MonthlyFactors: lazy(() => import('./pages/MonthlyFactors')),
  PositionGroups,
};

export default AnalogProducts;
